module.exports = __webpack_public_path__ + "img/car-none-right.e53dcfca.jpg";